import { createApi } from "@reduxjs/toolkit/query/react";
import {
  POLICY_AND_PROCEDURE_V2_CREATE,
  POLICY_AND_PROCEDURE_V2_DELETE,
  POLICY_AND_PROCEDURE_V2_LIST,
  POLICY_AND_PROCEDURE_V2_UPDATE,
  POLICY_AND_PROCEDURE_V2_VIEW,
  THERAPIST_POLICIES_LIST,
} from "config/apiPaths";
import axiosBaseQuery from "utils/axios/axiosBaseQuery";

export const policiesApi = createApi({
  reducerPath: "policiesApi",
  baseQuery: axiosBaseQuery({ baseUrl: "/policies" }),
  tagTypes: ["Policies", "Policy"],
  endpoints: (builder) => ({
    getPoliciesList: builder.query({
      query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } } = {}) => ({
        method: "PATCH",
        url: POLICY_AND_PROCEDURE_V2_LIST,
        data: { search, status, page, limit, sort },
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["Policies"],
    }),
    getTherapistPoliciesList: builder.query({
      query: ({ therapistId, search = "", page = 1, limit = 10, sort = { column: "agreed_at", direction: "DESC" } }) => ({
        method: "PATCH",
        url: `${THERAPIST_POLICIES_LIST}/${therapistId}/list`,
        data: { search, page, limit, sort },
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["Policies"],
    }),
    getPolicyDetails: builder.query({
      query: (id) => ({ method: "GET", url: `${POLICY_AND_PROCEDURE_V2_VIEW}/${id}` }),
      transformResponse: (response) => response?.data,
      providesTags: (_result, _error, id) => [{ type: "Policy", id }],
    }),
    createPolicy: builder.mutation({
      query: (data) => ({ method: "POST", url: POLICY_AND_PROCEDURE_V2_CREATE, data }),
      invalidatesTags: ["Policies"],
    }),
    updatePolicy: builder.mutation({
      query: ({ id, data }) => ({ method: "PUT", url: `${POLICY_AND_PROCEDURE_V2_UPDATE}/${id}`, data }),
      invalidatesTags: (_result, _error, { id }) => ["Policies", { type: "Policy", id }],
    }),
    deletePolicy: builder.mutation({
      query: (id) => ({ method: "DELETE", url: `${POLICY_AND_PROCEDURE_V2_DELETE}/${id}` }),
      invalidatesTags: ["Policies"],
    }),
  }),
});

export const {
  useGetPoliciesListQuery,
  useGetTherapistPoliciesListQuery,
  useGetPolicyDetailsQuery,
  useLazyGetPolicyDetailsQuery,
  useCreatePolicyMutation,
  useUpdatePolicyMutation,
  useDeletePolicyMutation,
} = policiesApi;
